import toast from "react-hot-toast";
import useGet from "../read/useGet";
import usePut from "../put/usePut";

export const usePettyCashSettings = () => {
  const { list: settingsData } = useGet({
    url: "petty-cash/get_settings",
  });

  const { handleAuth: saveSettingsMutation } = usePut({
    url: "petty-cash/set_settings",
    refreshUrl: ["petty-cash/get_settings"],
    onSuccess: () => {
      toast.success("Settings saved successfully");
    },
    onError: (err) => {
      toast.error(err?.response?.data?.message || "Failed to save settings");
    },
  });
  const { mutate: saveSettings, isLoading: isSaving } = saveSettingsMutation;

  return {
    settingsData,
    saveSettings,
    isSaving,
  };
};
